<template>
  <v-dialog v-model="dialogStatus" max-width="800" transition="dialog-bottom-transition">
    <v-card class="mx-auto">
      <div class="d-flex align-end my-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <!-- <v-icon color="white"> mdi-bookmark </v-icon> -->
          <v-icon small color="#fff">mdi-plus</v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">{{labels}}信息</span>
      </div>

      <!-- <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tabs-slider color="green"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in items"
          :key="item"
          :class="index == 0 ? 'oneTabs' : 'tabScene1'"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
      
      <v-tab-item class="tabBase">-->
      <v-form v-model="valid" class="px-15 mt-8">
        <v-select
          disabled
          v-model="form.course"
          :items="courseList"
          color="green lighten-1"
          item-text="name"
          item-value="_id"
          label="课程"
          :rules="[(v) => !!v || '课程不能为空']"
        ></v-select>

        <!-- <v-text-field
          v-model="form.orderNum"
          :label="labels+'编号 *'"
          color="green lighten-1"
          :rules="[
                (v) => {
                  let regs = /^[0-9]*$/;
                  if (!regs.test(v)) {
                    return `请输入正确的${labels}编号`;
                  }
                  return true;
                },
              ]"
          :hint="'请输入'+labels+'编号'"
        ></v-text-field> -->

        <v-text-field
          v-model="form.name"
          :label="labels+'名称 *'"
          color="green lighten-1"
          :rules="[
                (v) => !!v || `${labels}名称不能为空`,
                (v) => checkNameRule(v) || `${labels}名称过长`,
              ]"
          :hint = "'请输入实训'+labels+'名称'"
        ></v-text-field>
        <v-textarea
          v-model="form.description"
          :label="labels+'简介'"
          color="green lighten-1"
          rows="1"
          auto-grow
          :hint="'请描述实训'+labels+'简介,控制在1000字内'"
        ></v-textarea>
        <v-text-field
          v-model="form.manager"
          label="负责人 *"
          color="green lighten-1"
          :rules="[(v) => !!v || '负责人不能为空']"
          hint="请负责人先注册为系统用户，并输入负责人的系统用户名"
        ></v-text-field>
      </v-form>
      <!-- </v-tab-item>

        <v-tab-item class="tabScene">
          <v-list class="px-10 py-5">
            <div class="px-3">
              <v-text-field
                color="green lighten-1"
                v-model="keywords"
                label="请输入搜索的任务场景名称"
              ></v-text-field>
            </div>
            <div
              v-if="filterSceneList.length === 0"
              class="grey--text pa-10 d-flex justify-center"
            >
              暂无场景数据
            </div>
            <v-list-item-group
              v-model="form.taskEditor"
              active-class="deep-purple--text text--accent-4"
            >
              <v-list-item
                v-for="(item, i) in filterSceneList"
                :key="i"
                :value="item._id"
              >
                <v-list-item-content>
                  <v-list-item-title
                    class="text-body"
                    :v-text="item.name"
                  >{{item.name}}</v-list-item-title>

                  <v-list-item-subtitle
                    :v-text="item.description"
                  ></v-list-item-subtitle>

                </v-list-item-content>
                <v-spacer></v-spacer>
            
                <v-btn
                  class="btnSceneEdit"
                  icon
                  color="green"
                  small
                  @click.stop="toEditor(item)"
                >
                  <v-icon small>mdi-application-brackets</v-icon>
                </v-btn>
                <v-tooltip bottom color="grey lighten-5">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="success"
                      class="copyScene"
                      small
                      @click.native="copyEditor(item)"
                    >
                      <v-icon small v-bind="attrs" v-on="on"
                        >mdi-content-copy</v-icon
                      >
                    </v-btn>
                  </template>
                  <span style="color: black">复制场景</span>
                </v-tooltip>
                <v-btn
                  class="SceneEdit"
                  icon
                  color="green"
                  small
                  @click.stop="toEdit(item)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  class="btnSceneDel"
                  icon
                  color="red"
                  small
                  @click.stop="delScene(item)"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div class="py-5 d-flex justify-center align-center">
            <v-btn
              class="btnSceneAdd"
              icon
              color="green"
              @click.stop="
                $store.dispatch('editor/reverseShowSceneEdit', 'add')
              "
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-tab-item>

      </v-tabs-items>-->

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="submit">提交</v-btn>
        <v-btn
          color="gray"
          @click.stop="
            $store.dispatch('courseAndProject/reverseShowProjectEdit', 'close')
          "
        >取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  computed: {
    ...mapGetters(['project', 'showProjectEdit', 'projectType', 'course', 'sceneList']),
    dialogStatus: {
      get() {
        const status = this.showProjectEdit;
        return status === 'edit' || status === 'add';
      },
      set(val) {
        if (!val) {
          this.$store.dispatch('courseAndProject/reverseShowProjectEdit', 'close');
        }
      },
    },
    courseList() {
      return this.$store.state.courseAndProject.courseList;
    },
    filterSceneList() {
      console.log(this.sceneList, '======');
      return this.sceneList.filter(item => new RegExp(this.keywords).test(item.name));
    },
  },
  watch: {
    showProjectEdit(val) {
      if (val === 'edit') {
        this.form = Object.assign({}, this.project);
        this.returnProject(this.form)
      } else {
        this.$refs.form?.resetValidation();
        this.form = {
          course: this.course._id,
        };
      }
    },
    projectType(val) {
      if (val.sectionType && val.sectionType == 'xm') {
        this.labels = '项目';
      } else if (val.sectionType && val.sectionType == 'zj') {
        this.labels = '章节';
      } else if (val.sectionType && val.sectionType == 'qj') {
        this.labels = '情境';
      } else {
        this.labels = '章节';
      }
    },
  },
  data() {
    return {
      labels: '章节',
      tab: '',
      items: ['基本信息', '任务场景'],
      form: {},
      keywords: '',
      valid: false,
    };
  },
  methods: {
    returnProject(val){
       if (val.sectionType && val.sectionType == 'xm') {
        this.labels = '项目';
      } else if (val.sectionType && val.sectionType == 'zj') {
        this.labels = '章节';
      } else if (val.sectionType && val.sectionType == 'qj') {
        this.labels = '情境';
      } else {
        this.labels = '章节';
      }
    },
    checkNameRule(v) {
      if (v && v.length > 50) {
        return false;
      }
      return true;
    },
    async copyEditor(item) {
      this.$store.dispatch('editor/copyScene', item._id);
    },
    async delScene(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `场景 ${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('editor/removeScene', item);
      }
    },
    toEdit(sceneInfo) {
      this.$store.dispatch('editor/setSceneInfo', Object.assign({}, sceneInfo));
      this.$store.dispatch('editor/reverseShowSceneEdit', 'edit');
    },
    toEditor(sceneInfo) {
      this.$store.dispatch('editor/setSceneInfo', sceneInfo);
      // this.$router.push({
      //   path: `/editor/${this.project._id}/${sceneInfo._id}`,
      // });
      window.open(`/editor/${this.project._id}/${sceneInfo._id}`, '_blank');
      this.$store.dispatch('courseAndProject/reverseShowProjectEdit', 'close');
    },
    showEdit() {
      const sceneInfo = this.taskSceneList.find(item => item._id === this.form.taskEditor);
      this.$store.dispatch('editor/setSceneInfo', sceneInfo);
      this.$store.dispatch('editor/reverseShowSceneEdit', 'edit');
    },
    async fileChange(e) {
      console.log('更改文件', e);
    },
    async submit() {
      if (this.valid) {
        this.$store.dispatch('courseAndProject/saveProject', this.form);
        // this.$store.dispatch("courseAndProject/refreshCourseList");
      } else {
        this.$store.commit('global/SHOW_SNACKBAR', {
          color: 'yellow darken-2',
          text: '参数校验未通过',
        });
      }
    },
  },
  mounted() {
    let that = this;
    this.$EventBus.$on('onSetGuideTabs', function (data) {
      if (data == '1') {
        that.tab = 0;
      }
      if (data == '2') {
        that.tab = 1;
      }
    });
  },
};
</script>
